// extracted by mini-css-extract-plugin
export default {"logoStyle":"SVG_logoStyle__X1BA9"};